import React from "react";
import { links } from "../../config/links";

interface ChamadaFinalProps {
  onOpenModal: () => void;
}

const ChamadaFinal: React.FC<ChamadaFinalProps> = ({ onOpenModal }) => (
  <section className="border-b border-bone-300 bg-bone">
    <div className="mx-auto max-w-site px-5 py-16 lg:px-8 lg:py-20">
      <div className="grid gap-px border border-bone-300 bg-bone-300 lg:grid-cols-2">
        <div className="bg-white p-8 lg:p-12">
          <p className="eyebrow">Produtor</p>
          <h2 className="mt-4 font-display text-display-sm font-bold text-soil">
            Entre antes do lançamento
          </h2>
          <p className="mt-4 max-w-md text-base leading-relaxed text-soil/70">
            Deixe seu contato e avisamos quando o app estiver disponível para
            baixar.
          </p>
          <button onClick={onOpenModal} className="cta-solid mt-7">
            Quero o app
          </button>
        </div>

        <div className="bg-soil p-8 lg:p-12">
          <p className="eyebrow-light">Parceiro</p>
          <h2 className="mt-4 font-display text-display-sm font-bold text-white">
            Publique seu catálogo
          </h2>
          <p className="mt-4 max-w-md text-base leading-relaxed text-white/65">
            O cadastro leva alguns minutos. Depois da aprovação, você recebe o
            acesso ao painel por e-mail.
          </p>
          <a href={links.partnerSignup} className="cta-gold mt-7">
            Cadastrar minha empresa
          </a>
        </div>
      </div>
    </div>
  </section>
);

export default ChamadaFinal;
